import { PagePredictionProperties, PageTypes } from '@shared/types';
export function isPageProcessingTags(page) {
    return page.predictions[PagePredictionProperties.type] === PageTypes.processing_tags;
}
